import React from 'react';
import { Box, Fade, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  getCar360Loaded,
  getCarStatus,
  getRotate360Visibility,
} from '../../store/car-slice';

export default function Rotate360() {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));
  const rotate360Visibility = useSelector(getRotate360Visibility);
  const car360Loaded = useSelector(getCar360Loaded);
  const carStatus = useSelector(getCarStatus);

  return (
    <Fade in={rotate360Visibility && car360Loaded}>
      <Box
        sx={{
          zIndex: (theme) => theme.zIndex.appBar,
          position: 'absolute',
          top: carStatus === 'VDP' ? '15%' : '13%',
          left: carStatus === 'VDP' ? '50%' : 'unset',
          transform: carStatus === 'VDP' ? 'translateX(-50%)' : 'none',
        }}
      >
        <img
          alt="rotate 360"
          className="animate-fade-infinity"
          src="/rotate-360.svg"
          style={{
            width: isMobile ? 95 : 175,
            height: isMobile ? 50 : 105,
          }}
        />
      </Box>
    </Fade>
  );
}
